import React from 'react';
import classnames from 'classnames';
import { oneOf, bool } from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Icon from 'common/mdc/icon';

export const STATUS_LOGIN = 'LOGIN';
export const STATUS_LOGOUT = 'LOGOUT';
export const STATUS_ONLINE = 'ONLINE';
export const STATUS_OFFLINE = 'OFFLINE';
export const STATUS_CONNECTED = 'CONNECTED';
export const STATUS_DISCONNECTED = 'DISCONNECTED';
export const STATUS_UNKNOWN = 'UNKNOWN';

export const messages = defineMessages({
  [STATUS_LOGIN]: {
    id: 'node.status.loggedIn',
    defaultMessage: 'Logged in',
  },
  [STATUS_LOGOUT]: {
    id: 'node.status.loggedOut',
    defaultMessage: 'Logged out',
  },
  [STATUS_ONLINE]: {
    id: 'meter.status.online',
    defaultMessage: 'Online',
  },
  [STATUS_OFFLINE]: {
    id: 'meter.status.offline',
    defaultMessage: 'Offline',
  },
  [STATUS_CONNECTED]: {
    id: 'meter.status.connected',
    defaultMessage: 'Connected',
  },
  [STATUS_DISCONNECTED]: {
    id: 'meter.status.disconnected',
    defaultMessage: 'Disconnected',
  },
  [STATUS_UNKNOWN]: {
    id: 'meter.status.unknown',
    defaultMessage: 'Unknown',
  },
});

export const icons = {
  [STATUS_LOGIN]: 'check_circle',
  [STATUS_LOGOUT]: 'remove_circle',
};

const className = {
  [STATUS_LOGIN]: 'loggedIn',
  [STATUS_LOGOUT]: 'loggedOut',
};

const NodeStatus = ({ status, short, intl }) => (
  <span
    title={intl.formatMessage(messages[status])}
    className={classnames(
      'node-status',
      className[status],
    )}
  >
    <Icon>{icons[status]}</Icon>
    {!short && <FormattedMessage {...messages[status]} />}
  </span>
);

NodeStatus.propTypes = {
  status: oneOf([STATUS_LOGIN, STATUS_LOGOUT]).isRequired,
  intl: intlShape.isRequired,
  short: bool,
};

NodeStatus.defaultProps = {
  short: false,
};

export default injectIntl(NodeStatus);
